import { ComponentProps } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import TimePicker from 'modules/core/components/TimePicker'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

interface InputProps {
  value: string
  readonly: boolean
  isNotValid?: boolean
  inputBorderStyle?: ComponentProps<typeof Box>['border']
  onChange: (value: string) => void
  error?: string
}

const TimeInput = ({
  onChange,
  value,
  readonly,
  isNotValid = false,
  inputBorderStyle,
  error,
}: InputProps) => {
  const { access } = useCurrentSession()
  const is24Hours = access.timeFormat === 24

  return (
    <Box
      width={is24Hours ? 's96' : 's120'}
      border={inputBorderStyle}
      borderRadius={{ all: 'abs008' }}
    >
      <TimePicker
        value={value}
        readonly={readonly}
        isTimeFormat24H={is24Hours}
        isNotValid={!!isNotValid}
        onChange={onChange}
        error={error}
      />
    </Box>
  )
}

export default observer(TimeInput)
